import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
  geocodeByPlaceId,
} from "react-places-autocomplete";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Geocode from "react-geocode";
import Toastmodal from "../Toastmodal";
import { useNavigate } from "react-router-dom";
import SkillsMultiSelect from "./SkillsMultiSelect";
import { useAuthHandling } from '../useAuthhandling';

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
Geocode.setLocationType("ROOFTOP");

function Professionaladd() {
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  let navigate = useNavigate();
  const tokens = Cookies.get("a_token");
  const [toastmodal, setToastmodal] = useState(false);
  const [toastmessage, setToastmessage] = useState("");
  const [toasttype, setToasttype] = useState("");
  const [toastlarge, setToastlarge] = useState(false);
  const [mobile, setMobile] = useState("");
  const [sub,setSub]=useState(false);
  const [skill,setSkill]=useState(false);


  if (!tokens) {
    navigate("/");
  }
  const [prof, setProf] = useState({
    name: "",
    email: "",
    password: "",
    cpassword: "",
    professionalType: "",
    professionalCategory: "",
    subcategory: "",
    skills: "",
    experience: "",
    description: "",
  });
  const [selectedMulti, setselectedMulti] = useState([]);

  const [service, setService] = useState([]);
  const [subcat, setSubcat] = useState([]);
  const [location, setLocation] = useState({
    name: "Kochi, Kerala, India",
    lat: 9.9312,
    long: 76.2673,
  });

  const [loc, setLoc] = useState("Kochi, Kerala, India");

  const [addressstring, setaddressstring] = useState(
    "W7M9+9C Kochi, Kerala, India"
  );

  const [formerror, setError] = useState({});
  const [formerror1, setError1] = useState({});
  const [verified,setVerified]=useState(false);
  const [suspended,setSuspended]=useState(false);
  const [featured, setFeatured] = useState(false);
  const [countrycodeval,setCountrycodeval]=useState('');
  const [loginValuenewph,setLoginValuenewph]=useState('');
  const [countrycode,setCountryCode]=useState('');

  let name, value;
  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setProf({ ...prof, [name]: value });
  };

  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    if (!values.name) {
      errors.name = "Firstname is required!";
    }

    if (!values.email) {
      errors.email = "Email is required!";
    } else if (!regex.test(values.email)) {
      errors.email = "This is not a valid email format!";
    }

    // if (!values.password) {
    //   errors.password = "password is required!";
    // }
    // else{
    //   if (!values.password.match(/^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&]).*$/)) {
    //     errors.password = "The password must contain minimum 8 characters and one number, one lowercase letter, one upper case letter and a special character.";
    //   }
    // }
    // if (!values.cpassword) {
    //   errors.cpassword = "confirm password is required!";
    // }
    // if(values.password && values.cpassword){
    //   if(values.password!==values.cpassword){
    //     errors.cpassword = "password and confirm password must be same!";

    //   }
    // }
    if (!values.professionalType) {
      errors.professionalType = "Type is required!";
    }
    if (!values.professionalCategory) {
      errors.professionalCategory = "Category is required!";
    }
    if (!values.subcategory) {
      errors.subcategory = "Sub category is required!";
    }

    if (!values.experience) {
      errors.experience = "experience is required!";
    }
    if (!values.description) {
      errors.description = "Description is required!";
    }
    if (!values.skills) {
      errors.skills = "Skills is required!";
    }
    return errors;
  };

  const validate1 = (values) => {
    const errors = {};
    if (values < 4) {
      errors.mobile = "Contact number required!";
    }
    return errors;
  };
  const getServices = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/service-category/service-category-select?level=1`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
          "Content-type": "application/json; charset=UTF-8",
        },
      }
    );

   

    if (res.status === 200) {
      const data1 = await res.json();
      const data = data1.data;
      setService(data);

        }
    else if(res.status === 401){
      handleUnauthorized();
      getServices();
    }
    else {
      toast.error("error!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const getServices1 = async (e) => {
    if (prof.professionalCategory) {
      const res = await fetch(
        `${Config.apiurl}/api/v1/crm/service-category/service-category-select?level=2`,
        {
          method: "POST",
          body: JSON.stringify({
            levelOneCategory: prof.professionalCategory,
          }),
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );

      if (res.status === 200) {
        const data1 = await res.json();
        const data = data1.data;
        setSubcat(data[0].subCategories);

        } 
      else if(res.status === 401){
        handleUnauthorized();
        getServices1();
      }
      else {
        toast.error("error!", {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };

  const PostData = async (e) => {
    e.preventDefault();
    const {
      name,
      email,
      password,
      cpassword,
      professionalCategory,
      subcategory,
      professionalType,
      experience,
      description,
      skills
    } = prof;
    const ress = validate(prof);
    const ress1 = validate1(mobile);

    setError1(ress1);
    setError(ress);
    if (
      !ress.email &&
      !ress.name &&
      !ress.description &&
      !ress1.mobile &&
      !ress.password &&
      !ress.cpassword &&
      !ress.professionalCategory &&
      !ress.professionalType &&
      !ress.experience &&
      !ress.subcategory &&
      !ress.skills
    ) {
      // axios.post(`${Config.apiurl}/api/v1/crm/professional/create-professional`, formData, { headers: {
      //     Authorization: `Bearer ${Cookies.get('token')}`,
      // },})
      const res = await fetch(
        `${Config.apiurl}/api/v1/crm/professional/create-professional`,
        {
          method: "POST",

          body: JSON.stringify({
            name: prof.name,
            email: prof.email,
            mobile: loginValuenewph,
            countryCode:countrycodeval,
            password: '#testPass1',
            confirmPassword: '#testPass1',
            // password: prof.password,
            // confirmPassword: prof.cpassword,
            professionalCategory: prof.professionalCategory,
            professionalType: prof.professionalType,
            subCategory:prof.subcategory,
            experience: prof.experience,
            description: prof.description,
            verified:verified,
            // suspended:suspended,
            squareFeetRate:prof.squareFeetRate,
            workingArea:prof.workingArea,
            featured:featured,
            skills:prof.skills,
            inviteId: "",
            location: loc,
            latitude: location.lat,
            longitude: location.long,
            google_address_string: addressstring,
          }),
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );

      if (res.status === 200) {
        setToastmodal(true);
        setToastmessage("Sucessfully Created Account");
        setToasttype("success");
        setToastlarge(false);
        setTimeout(() => navigate("/dashboard"), 3000);

      
      } 
      else if(res.status === 401){
        handleUnauthorized();
        PostData();
      }
      else {
        const data = await res.json();

        setToastmodal(true);
        setToastmessage(data.message);
        setToasttype("error");
        setToastlarge(true);
       
      }
    }
  };

  const handleChange = async (value) => {
    setLocation({
      name: value,
      lat: location.lat,
      long: location.long,
    });
    setLoc(value);
  };

  const handleSelect = async (value) => {
    const results = await geocodeByAddress(value);
    const latLng = await getLatLng(results[0]);
    Geocode.fromLatLng(latLng.lat, latLng.lng).then((response) => {
      const address = response.results[0].formatted_address;
      setaddressstring(address);
    });
    setLocation({
      name: value,
      lat: latLng.lat,
      long: latLng.lng,
    });
    setLoc(value);
  };

  useEffect(() => {
    getServices();
    getServices1();
   
  }, [prof.professionalCategory]);
  // const handleInputsphone = (value) => {
  //   setMobile(value);
  // };
  const handleInputsphone = (phone,country) => {
    // let value = e.target.value;
    let value =phone;
    setMobile(phone);
    setCountryCode(country.countryCode)
    setCountrycodeval(country.dialCode);
    const phoneWithoutCode = value.replace(`+${country.dialCode}`, "").trim();
    setLoginValuenewph(phoneWithoutCode);

  }

  const handleSkillsInput = (val) => {
    let name = "skills";
    let value = val;
    setProf({ ...prof, [name]: value });
  };
  return (
    <>
      <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row grid-margin">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Professional Add</h4>
                      <form className="forms-sample" >
                        <div className="row">
                        <div className="form-group col-sm-12 col-md-6">
                          <label htmlFor="exampleInputUsername1">Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Name"
                            name="name"
                            value={prof.name}
                            onChange={handleInputs}
                            required
                          />
                          <label style={{ color: "red" }}>
                            {formerror.name}
                          </label>
                        </div>

                        <div className="form-group col-sm-12 col-md-6">
                          <label htmlFor="exampleInputUsername1">Email</label>
                          <input
                            type="email"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Email"
                            name="email"
                            value={prof.email}
                            onChange={handleInputs}
                            required
                          />
                          <label style={{ color: "red" }}>
                            {formerror.email}
                          </label>
                        </div>
                        <div className="form-group number col-sm-12 col-md-6">
                          <label htmlFor="exampleInputUsername1">Mobile</label>
                          <PhoneInput
                            country={"in"}
                            enableSearch={true}
                            value={mobile}
                            onChange={ handleInputsphone}
                            // onChange={(phone) => handleInputsphone(phone)}
                          />
                          <label style={{ color: "red" }}>
                            {formerror1.mobile}
                          </label>
                        </div>

                        <div className="form-group col-md-6">
                            <label htmlFor="exampleInputUsername1">
                             Verified ?
                            </label>
                            <select
                              id="professionalType"
                              className="form-control"
                              name="verified"
                              onChange={(e) => setVerified(e.target.value)}
                              style={{ color: "black",height:"35px" }}
                              value={verified}
                              
                            >
                              <option>Select</option>
                              <option name="verified" value={true}>
                                True
                              </option>
                              <option name="verified" value={false}>
                                False
                              </option>
                            </select>
                          </div>
                          <div className="form-group col-md-6">
                            <label htmlFor="exampleInputUsername1">
                              Featured ?
                            </label>
                            <select
                              id="professionalType"
                              className="form-control"
                              name="featured"
                              onChange={(e) => setFeatured(e.target.value)}
                              style={{ color: "black" ,height:"45px"}}
                              value={featured}
                            >
                              <option>Select</option>
                              <option name="featured" value={true}>
                                True
                              </option>
                              <option name="featured" value={false}>
                                False
                              </option>
                            </select>
                          </div>
                          <div className="form-group number col-sm-12 col-md-6">
                            <label htmlFor="exampleInputUsername1">
                              Square Feet Rate
                            </label>
                            <input
                              type="number"
                              className="form-control form_dis"
                              id="exampleInputUsername1"
                              placeholder="Square feet rate"
                              name="squareFeetRate"
                              value={prof.squareFeetRate}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>
                              {formerror.squareFeetRate}
                            </label>
                          </div>
                          <div className="form-group number col-sm-12 col-md-6">
                            <label htmlFor="exampleInputUsername1">
                            Working Area
                            </label>
                            <input
                              type="text"
                              className="form-control form_dis"
                              id="exampleInputUsername1"
                              placeholder="Working Area"
                              name="workingArea"
                              value={prof.workingArea}
                              onChange={handleInputs}
                             
                            />
                            <label style={{ color: "red" }}>
                              {formerror.workingArea}
                            </label>
                          </div>
                        {/* <div className="form-group col-sm-12 col-md-6">
                          <label htmlFor="exampleInputUsername1">
                            Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Password"
                            name="password"
                            value={prof.password}
                            onChange={handleInputs}
                            required
                          />
                          <label style={{ color: "red" }}>
                            {formerror.password}
                          </label>
                        </div>
                        <div className="form-group col-sm-12 col-md-6">
                          <label htmlFor="exampleInputUsername1">
                            Confirm Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Confirm password"
                            name="cpassword"
                            value={prof.cpassword}
                            onChange={handleInputs}
                            required
                          />
                          <label style={{ color: "red" }}>
                            {formerror.cpassword}
                          </label>
                        </div> */}
                       
                          <div className="form-group col-sm-12 col-md-6">
                            <label htmlFor="exampleInputUsername1">
                              Professional Type
                            </label>
                            <select
                              id="professionalType"
                              className="form-select professional_select"
                              name="professionalType"
                              onChange={handleInputs}
                              style={{ color: "black" }}
                            >
                              <option>Select</option>
                              <option name="professionalType" value="freelance">
                                Freelance
                              </option>
                              <option name="professionalType" value="company">
                                Company
                              </option>
                            </select>
                            <label style={{ color: "red" }}>
                              {formerror.professionalType}
                            </label>
                          </div>
                          <div className="form-group col-sm-12 col-md-6">
                            <label htmlFor="exampleInputUsername1">
                              Professional Category
                            </label>
                            <select
                              className="form-select professional_select"
                              name="professionalCategory"
                              onChange={(e)=>{handleInputs(e);setSub(true)}}
                              style={{ color: "black" }}
                            >
                              <option>Select</option>
                              {service.map((element) => {
                                return (
                                  <option
                                    name="professionalCategory"
                                    value={element._id}
                                  >
                                    {element.categoryName}
                                  </option>
                                );
                              })}
                            </select>
                            <label style={{ color: "red" }}>
                              {formerror.professionalCategory}
                            </label>
                          </div>
                         {sub===true?
                          <div className="form-group col-sm-12 col-md-6">
                            <label htmlFor="exampleInputUsername1">
                              Sub Category
                            </label>
                            <select
                              className="form-select professional_select"
                              name="subcategory"
                              onChange={(e)=>{handleInputs(e);setSkill(true)}}
                              style={{ color: "black" }}
                            >
                              <option>Select</option>
                              {subcat.map((element, index) => {
                                return (
                                  <option
                                    name="subcategory"
                                    value={element._id}
                                  >
                                    {element.categoryName}
                                  </option>
                                );
                              })}
                            </select>
                            <label style={{ color: "red" }}>
                              {formerror.subcategory}
                            </label>
                          </div>
                     :""}
                     {skill===true?
                     <div className="form_input_box col-sm-12 col-md-6">
                        <div className="form-group professional_skill_mul">
                          <label htmlFor="exampleInputUsername1">Skills</label>
                          <SkillsMultiSelect
                professionalCategory={prof.professionalCategory}
                professionalSubCategory={prof.subcategory}
                handleSkillsInput={handleSkillsInput}
              />
                          
                          <label style={{ color: "red" }}>
                            {formerror.skills}
                          </label>
                        </div>
                      </div>
                        :""}
                        <div className="form-group number col-sm-12 col-md-6">
                          <label htmlFor="exampleInputUsername1">
                            Experience
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Experience"
                            name="experience"
                            value={prof.experience}
                            onChange={handleInputs}
                            required
                          />
                          <label style={{ color: "red" }}>
                            {formerror.experience}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Description
                          </label>
                          <textarea
                            className="form-control"
                            id="description"
                            type="text"
                            rows="5"
                            name="description"
                            placeholder="Description"
                            autoComplete="off"
                            required
                            value={prof.description}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.description}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Location
                          </label>
                          <PlacesAutocomplete
                            value={location.name}
                            onChange={handleChange}
                            onSelect={handleSelect}
                            name="location"
                          >
                            {({
                              getInputProps,
                              suggestions,
                              getSuggestionItemProps,
                              loading,
                            }) => (
                              <div className="position-relative">
                                <input
                                  className="form-control"
                                  {...getInputProps({
                                    placeholder: " Enter your location",
                                  })}
                                  required
                                />

                                <div className="autocomplete-dropdown-container">
                                  {loading ? <div>...Loading</div> : null}

                                  {suggestions.map((suggestion, key) => {
                                    const style = suggestion.active
                                      ? {
                                          backgroundColor: "#fafafa",
                                          cursor: "pointer",
                                          border: "1px solid #d2d2d2",
                                        }
                                      : {
                                          backgroundColor: "#ffffff",
                                          cursor: "pointer",
                                          border: "1px solid #d2d2d2",
                                        };

                                    return (
                                      <div
                                        className="form-conterol"
                                        {...getSuggestionItemProps(suggestion, {
                                          style,
                                        })}
                                        key={key}
                                      >
                                        {suggestion.description}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </PlacesAutocomplete>
                          {/* <input
                          className="form-control"
                          id="location"
                          type="text"
                          name="location"
                          placeholder="Location"
                          autoComplete="off"
                          required
                          value={location.name}
                        /> */}
                        </div>

                      
                        </div>
                        <button
                          type="submit"
                          onClick={PostData}
                          className="btn btn-primary me-2"
                        >
                          Submit
                        </button>

                        <ToastContainer />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {toastmodal ? (
        <Toastmodal
          setToast={setToastmodal}
          message={toastmessage}
          type={toasttype}
          large={toastlarge}
        />
      ) : (
        ""
      )}
    </>
  );
}
export default Professionaladd;
